import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
import { SignIn } from "@/pages/sign-in/SignIn";

const searchParams = z.object({
	success: z
		.union([z.literal("password-reset"), z.literal("email-verified")])
		.optional(),
});

export const Route = createFileRoute("/auth/signin")({
	head: () => ({
		meta: [{ title: "Sign in - BitEasy" }],
	}),
	validateSearch: zodValidator(searchParams),
	component: SignIn,
});
